<template>
    <div>
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-capitalize">Auth Report</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>
                            <li class="breadcrumb-item active text-capitalize"><i class="fas fa-list"></i> GGR
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="container-fluid">
                <data-table-wrapper
                    ref="dataTable"
                    :columns="columns"
                    :filters="filters"
                    :load-data-callback="loadDataCallback"
                    :filter-defaults="filterDefaults"
                    disable-primary-column="true"
                    disable-edit-action="true"
                    disable-delete-action="true"
                    endpoint="/auth-report"
                    api-service="analytics"
                >
                    <template v-slot:filter-buttons>
                        <button class="btn btn-default float-right" @click="doExport">
                            <span v-if="!exportInProgress">
                                <i class="fa fa-cloud-download"></i> {{ $t('Export') }}
                            </span>
                            <span v-else>
                                <i class="fas fa-spinner fa-pulse"></i> {{ $t('Export') }}
                            </span>
                        </button>
                    </template>
                </data-table-wrapper>
            </div>

        </section>
    </div>
</template>

<script>
import * as dateUtils from '../helpers/dateUtils';
import DataTableWrapper from '../components/DataTableWrapper';
import {mapGetters} from "vuex";

export default {
    components: {
        DataTableWrapper,
    },
    data() {
        let self = this;
        return {
            exportInProgress: false,
            loadDataCallback: (component, respData) => {
                component.items = respData;
                component.pagination.onPage = component.pagination.total = component.items.length
                component.pagination.page = 1;
                component.showEmpty = true;
            },
            filters: [
                {
                    field: 'fromDate',
                    placeholder: 'From Date',
                    label: 'From Date',
                    type: 'date-picker',
                    shortcuts: dateUtils.getFilterShortcuts()
                },
                {
                    field: 'toDate',
                    placeholder: 'To Date',
                    label: 'To Date',
                    type: 'date-picker',
                    shortcuts: dateUtils.getFilterShortcuts()
                },
                {
                    field: 'partnerIds',
                    placeholder: 'Select partners',
                    label: 'Partners',
                    type: 'multiselect',
                    optionLabel: 'name',
                    multiple: true,
                    getValue: (partners) => { return partners ? partners.map(partner => partner.id) :[]},
                    getOptions: () => this.getPartners,
                    trackBy: 'id'
                },
                {
                    field: 'operatorIds',
                    placeholder: 'Select operators',
                    label: 'Operators',
                    type: 'multiselect',
                    optionLabel: 'name',
                    multiple: true,
                    getValue: (operators) => { return operators ? operators.map(operator => operator.id) : [] },
                    getOptions: () => this.getOperatorsOptions,
                    trackBy: 'id'
                },
                {
                    field: 'gameIds',
                    placeholder: 'Select games',
                    label: 'Games',
                    type: 'multiselect',
                    optionLabel: 'name',
                    multiple: true,
                    getValue: (games) => { return games ? games.map(game => game.id) : [] },
                    getOptions: () => this.getGames,
                    trackBy: 'id'
                },
            ],
            columns: [
                {
                    field: 'partnerId',
                    title: 'Partner',
                    sorting: false,
                    callback: ({row}) => {
                        return self.getPartner(row.partnerId.toString()).name;
                    },
                },
                {
                    field: 'operatorId',
                    title: 'Operator',
                    sorting: false,
                    callback: ({row}) => {
                        return self.getOperator(row.operatorId.toString()).name;
                    },
                },
                {
                    field: 'gameId',
                    title: 'Game',
                    sorting: false,
                    callback: ({row}) => {
                        return self.getGame(row.gameId).name;
                    },
                },
                {
                    field: 'initCount',
                    title: 'Sessions init',
                    sorting: false,
                },
                {
                    field: 'reinitCount',
                    title: 'Sessions reinit',
                    sorting: false,
                },
                {
                    field: 'usersCount',
                    title: 'Users',
                    sorting: false,
                },
                {
                    field: 'usersWithBetsCount',
                    title: 'Users With Bets',
                    sorting: false,
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'getGames',
            'getGame',
            'getPartners',
            'getPartner',
            'getOperators',
            'getOperator',
            'getCurrency',
            'isOperator',
        ]),
        getOperatorsOptions() {
            return this.getOperators.filter((operator) => {
                let selectedPartnerIds = this.$refs.dataTable.getFilterValue('partnerIds');
                if (selectedPartnerIds.length === 0) {
                    return true;
                }

                if (!operator.partnerId) {
                    return false;
                }

                return selectedPartnerIds.includes(operator.partnerId);
            });
        },
        filterDefaults() {
            return {
                fromDate: dateUtils.getTodayDate(),
            }
        },
    },
    methods: {
        doExport() {
            if (this.exportInProgress) {
                return;
            }
            this.exportInProgress = true;
            this.$exportService.doExport('auth-report', this.$refs.dataTable.getPageQuery()).finally(() => {
                this.exportInProgress = false;
            });
        },
    },
    mounted() {
    },
};
</script>
